var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderStock',{attrs:{"header":"คลัง","img_header":_vm.header_image,"link_back":"stockinout"}}),_c('MenuStockList'),_c('AddLotoutList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }